import StripePayment, { StripePaymentButton } from './components/StripePayment';

export default (editor, opts = {}) => {
  const dc = editor.DomComponents;
  const bm = editor.BlockManager;
  const { labels, types, labelShoppingCartCategory } = opts;
  StripePaymentButton(
    bm,
    labelShoppingCartCategory,
    labels.stripePaymentButton,
    types.stripePaymentButton,
    opts,
  );
  StripePayment(dc, labels.stripePaymentButton, types.stripePaymentButton, opts);
};
